export const getSelectedShippingType = (shippingOptions, shippingOption, isISPUChoosen = '') => {
  if (!shippingOptions && shippingOptions.length) {
    return -1;
  }

  if (isISPUChoosen === 'ISPU') {
    return {
      shippingOptionId: 'ISPU',
    };
  }

  const selectedShippingType = shippingOptions.filter((item) => item.addedShippingOptionId === 'true');
  if (selectedShippingType && selectedShippingType.length) {
    return selectedShippingType[0];
  }

  if (shippingOption) {
    return shippingOptions[0];
  }
  return shippingOptions?.[0]?.shippingOptionId;
};

export const getCurrentShippingValue = (cartDetails) => {
  const shippingDetails = cartDetails?.shippingDetails?.length ? cartDetails.shippingDetails[0] : {};
  if (shippingDetails?.shippingCode) {
    return shippingDetails?.shippingCode;
  }
  if (shippingDetails?.storeinfo) {
    return 'ISPU';
  }
  return null;
};

export const isISPUSelected = (cartDetailsFromCheckDetails) => {
  const ISPUSelected = cartDetailsFromCheckDetails?.storeinfo;
  if (ISPUSelected) {
    return 'ISPU';
  }
  return null;
};

export const isPaymentNeeded = (payment) => {
  let isNeeded = true;
  if (!payment || payment === 'null' || payment === 'undefined') {
    return isNeeded;
  }

  Object.entries(payment).forEach((entry) => {
    if (entry && entry.length > 1 && entry[0] !== '' && entry[1].paymentType !== '') {
      isNeeded = false;
    }
  });

  return isNeeded;
};
